import { render, staticRenderFns } from "./AskQuestion.vue?vue&type=template&id=6cc7f023&"
import script from "./AskQuestion.vue?vue&type=script&lang=js&"
export * from "./AskQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports